import { createApi } from '@reduxjs/toolkit/query/react';
import dayjs from 'dayjs';
import { urls } from '../../utils/helpers/ApiClient';
import axiosFetchBase from '../axiosFetchBase';

export const dissertationsApi = createApi({
  reducerPath: 'dissertationsApi',
  keepUnusedDataFor: 0,
  baseQuery: axiosFetchBase,
  endpoints: (builder) => ({
    getDissertations: builder.query({
      query() {
        return {
          url: `${urls.dissertations}`,
          method: 'GET',
        };
      },
    }),
    getDissertationDetail: builder.query({
      query(id) {
        return {
          url: urls.dissertationDetail(id),
          method: 'GET',
        };
      },
    }),
    saveDissertation: builder.mutation({
      query(req) {
        const formData = new FormData();
        Object.entries(req.body).forEach(([key, value]) => {
          const normalizedValue = dayjs.isDayjs(value)
            ? value.format('YYYY-MM-DD')
            : value;

          if (
            normalizedValue !== undefined &&
            normalizedValue !== null &&
            normalizedValue !== ''
          ) {
            formData.append(key, normalizedValue);
          }
        });
        if (req.id) {
          // Toto je workaround na to, že to nejde
          formData.append('_method', 'put');
          return {
            url: urls.dissertationDetail(req.id),
            // Malo by tu byť PUT, ale potom je v Laraveli prázdny request
            // Vraj to známa dlhoročná chyba v PHP
            method: 'POST',
            data: formData,
          };
        } else {
          return {
            url: urls.dissertations,
            method: 'POST',
            data: formData,
          };
        }
      },
    }),

    deleteDissertation: builder.mutation({
      query(id) {
        return {
          url: urls.dissertationDetail(id),
          method: 'DELETE',
        };
      },
    }),
  }),
});

export const {
  useGetDissertationsQuery,
  useGetDissertationDetailQuery,
  useDeleteDissertationMutation,
  useSaveDissertationMutation,
} = dissertationsApi;
